import React, { useState } from 'react'
import { Button, Card, Col, Image, Spinner } from 'react-bootstrap'
import { BsFillFileEarmarkPdfFill, BsXLg } from 'react-icons/bs'
import Error_false from '../../error/error-false'
import { useDropzone } from 'react-dropzone'
import SwalCustom from '../../../alert/swal-custom'
import IconDownload from '../../../images/Action/Download.svg'
import IconView from '../../../images/pdf.svg'
import {
  getTypeFileAPI,
  updateFileEducationAPI
} from '../../../services/education'
import Swal from 'sweetalert2'

function FileEducationTable({
  idcode,
  fnData,
  isFile,
  educationId,
  docTypeId
}) {
  const [isSave, setIsSave] = useState(false)
  const [filedoc, setFileDoc] = useState([])
  const [filedocs, setFileDocs] = useState([])

  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 8000000,
    accept: {
      // 'image/*': ['.png', '.jpg', '.jpeg', '.gif']
      'pdf/pdf': ['.pdf']
    },
    onDrop: (acceptedFiles) => {
      setFileDoc(acceptedFiles.map((file) => Object.assign(file)))
    },
    onDropRejected: () => {
      Swal.fire({
        icon: 'error',
        title: 'You can only upload 1 file & maximum size of 8 MB.',
        showConfirmButton: false,
        timer: 3000
      })
    }
  })

  const createFilesDoc = async () => {
    setIsSave(true)
    var c_formData = new FormData()
    c_formData.append('file', filedoc[0])
    c_formData.append('orgId', idcode.orgId)
    c_formData.append('code', idcode.code)

    c_formData.append('docTypeId', docTypeId)
    c_formData.append('educationId', educationId)
    const data = await updateFileEducationAPI(c_formData)
    if (data?.status) {
      SwalCustom({
        title: 'Success!',
        text: 'Your Document has been attached.',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setFileDoc([])
        fnData()
      })
    } else {
      Error_false(data)
    }
    setIsSave(false)
  }

  const getFilesDocs = async () => {
    const body = {
      ...idcode,
      educationId,
      docTypeId
    }
    const result = await getTypeFileAPI(body)
    if (!result) return
    void window.open(result.result, '_blank')
  }

  const renderFilePreview = (file) => {
    if (file.type.startsWith('image')) {
      return (
        <img
          width={38}
          height={38}
          alt={file.name}
          src={URL.createObjectURL(file)}
        />
      )
    } else {
      return (
        <BsFillFileEarmarkPdfFill
          className="opacity-25 mt-2"
          style={{
            fontSize: '2rem'
          }}
        />
      )
    }
  }
  const fileList = filedoc.map((file) => (
    <span key={file.name} className="d-flex ">
      <div className="d-flex ">
        <div>{renderFilePreview(file)}</div>
        <div className="my-auto ms-3">
          <p className="mb-0 small">{file.name}</p>
          <span className="font-small-2 fw-lighter">
            {' '}
            {Math.round(file.size / 100) / 10 > 1000
              ? `${(Math.round(file.size / 100) / 10000).toFixed(1)} mb`
              : `${(Math.round(file.size / 100) / 10).toFixed(1)} kb`}
          </span>
        </div>
      </div>
      <div >
        <BsXLg fontSize={20} onClick={() => handleRemoveFile(file)}/>
      </div>
    </span>
  ))

  const handleRemoveAllFiles = () => {
    setFileDocs([])
    setFileDoc([])
  }

  const handleRemoveFile = (file) => {
    const uploadedFiles = filedocs
    const filtered = uploadedFiles.filter((i) => i.name !== file.name)
    setFileDoc([...filtered])
  }
  const htmlUploadFile = (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      <>
        <Image
          style={{
            width: '16px'
          }}
          src={IconDownload}
          className="pointer-event"
        />
        {/* <div className="text-secondary small">(max 8 MB)</div> */}
      </>
    </div>
  )

  return (
    <>
      <div className="float-center">
        {isFile ? (
          <Col xl={12} md={12}>
            {filedoc.length ? (
              <div className="mt-3" style={{ width: '80%' }}>
                <Card>{fileList}</Card>
                {filedoc.length > 1 ? (
                  <span className="text-danger small">
                    สามารถอัปโหลดไฟล์ได้เพียง 1 ไฟล์เท่านั้น*
                  </span>
                ) : (
                  <></>
                )}
                <div className="mt-2">
                  <Button
                    variant="outline-danger"
                    disabled={isSave}
                    onClick={handleRemoveAllFiles}
                  >
                    นำออก
                  </Button>
                  <Button
                    disabled={isSave}
                    className="ms-3"
                    onClick={createFilesDoc}
                  >
                    {isSave ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        className="me-2"
                        aria-hidden="true"
                      />
                    ) : (
                      <BsFillFileEarmarkPdfFill className="me-2" />
                    )}
                    {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                  </Button>
                </div>
              </div>
            ) : (
              <div className="d-flex gap-3 justify-content-center">
                <Image
                  className="pointer-event"
                  onClick={getFilesDocs}
                  style={{ width: '18px' }}
                  src={IconView}
                />

                {htmlUploadFile}
              </div>
            )}
          </Col>
        ) : (
          <>
            {filedoc.length ? (
              <div className="mt-3 " style={{ width: '100%' }}>
                <Card className="p-1">{fileList}</Card>
                {filedoc.length > 1 ? (
                  <span className="text-danger small">
                    สามารถอัปโหลดไฟล์ได้เพียง 1 ไฟล์เท่านั้น*
                  </span>
                ) : (
                  <></>
                )}
                <div className="mt-2">
                  <Button
                    variant="outline-danger"
                    disabled={isSave}
                    onClick={handleRemoveAllFiles}
                  >
                    นำออก
                  </Button>
                  <Button
                    disabled={isSave}
                    className="ms-3"
                    onClick={createFilesDoc}
                  >
                    {isSave ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        className="me-2"
                        aria-hidden="true"
                      />
                    ) : (
                      <BsFillFileEarmarkPdfFill className="me-2" />
                    )}
                    {isSave ? 'กำลังบันทึกไฟล์...' : 'บันทึกไฟล์'}
                  </Button>
                </div>
              </div>
            ) : (
              <div className="d-flex gap-3 justify-content-center">
                {htmlUploadFile}
              </div>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default FileEducationTable
